import React, { useEffect } from "react";

import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
// import ScrollRestoration from 'react-router-scroll-restoration';
// import ScrollMemory from 'react-router-scroll-memory';

import i18n from "./i18n";
import { ModelProvider } from "./hooks/modelcontex";
import BrowserRedirect from "./Componets/BrowserRedirect";
import PopupRedirect from "./Componets/PopupRedirect";
import ModifiedRedirect from "./Componets/ModifiedRedirect";
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const loginUrl = "https://www.storytent.in/login"; // Example Google login URL

// Added serviceWorker for YT iframe(credentialless) and zoom gallery view
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`https://www.storytent.in/coi-sw.js`, { scope: "/" })
    .then((registration) => {
      console.log(
        "COOP/COEP Service Worker registered with scope:",
        registration.scope
      );
    })
    .catch((error) => {
      console.error("COOP/COEP Service Worker registration failed:", error);
    });
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`http://localhost:3001/coi-sw.js`, { scope: "/" })
    .then((registration) => {
      console.log(
        "COOP/COEP Service Worker registered with scope:",
        registration.scope
      );
    })
    .catch((error) => {
      console.error("COOP/COEP Service Worker registration failed:", error);
    });
}

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        {/* <ScrollRestoration auto={true}> */}
        <ModelProvider>
          <BrowserRedirect />
          {/* <OriginalRedirect url={loginUrl} /> */}
          {/* <ModifiedRedirect url={loginUrl} /> */}
          {/* <PopupRedirect url={loginUrl} /> */}
          <App />
        </ModelProvider>
        {/* </ScrollRestoration> */}
      </I18nextProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);

// ReactDOM.render(
//   <BrowserRouter>
//   <React.StrictMode>
//     <I18nextProvider i18n={i18n}>
//     <ScrollMemory />
//     <App />

//   </I18nextProvider>
//   </React.StrictMode>
//   </BrowserRouter>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
